import React, { useState, useEffect } from 'react';
import { FaPlus, FaEdit, FaTrash, FaFileImport } from 'react-icons/fa';
import api from '../api';
import ProdutoSemControleForm from './ProdutoSemControleForm';
import ProdutosSemControleImport from './ProdutosSemControleImport';

const ProdutosSemControleList = () => {
    const [produtos, setProdutos] = useState([]);
    const [busca, setBusca] = useState('');
    const [produtoEditado, setProdutoEditado] = useState(null);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [mostrarImport, setMostrarImport] = useState(false);

    useEffect(() => {
        carregarProdutos();
    }, []);

    const carregarProdutos = async () => {
        try {
            const response = await api.get('/produtos-sem-controle');
            setProdutos(response.data);
        } catch (error) {
            console.error('Erro ao carregar produtos:', error);
        }
    };

    const handleExcluir = async (id) => {
        if (!window.confirm('Tem certeza que deseja excluir este produto?')) {
            return;
        }

        try {
            await api.delete(`/produtos-sem-controle/${id}`);
            alert('Produto excluído com sucesso!');
            carregarProdutos();
        } catch (error) {
            alert(error.response?.data?.error || 'Erro ao excluir produto');
        }
    };

    // ✅ FUNÇÃO PARA FORMATAR PESO
    const formatarPeso = (peso, unidade) => {
        if (!peso || ['unidade', 'caixa'].includes(unidade?.toLowerCase())) {
            return '-';
        }
        
        const numero = parseFloat(peso);
        if (isNaN(numero)) return '-';
        
        return numero.toLocaleString('pt-BR', {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3
        });
    };

    const produtosFiltrados = produtos.filter(p =>
        p.nome.toLowerCase().includes(busca.toLowerCase())
    );

    return (
        <div className="max-w-6xl mx-auto mt-10 bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-gray-700 mb-6">
                Produtos sem Controle de Estoque
            </h2>

            {/* Busca e Ações */}
            <div className="flex gap-4 mb-6">
                <input
                    type="text"
                    placeholder="Buscar produto..."
                    value={busca}
                    onChange={(e) => setBusca(e.target.value)}
                    className="flex-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <button
                    onClick={() => setMostrarImport(true)}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center gap-2"
                >
                    <FaFileImport />
                    Importar Excel
                </button>
                <button
                    onClick={() => {
                        setProdutoEditado(null);
                        setMostrarModal(true);
                    }}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                    <FaPlus />
                    Novo Produto
                </button>
            </div>

            {/* Tabela Desktop */}
            <div className="hidden md:block overflow-x-auto">
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border p-3 text-left">Nome</th>
                            <th className="border p-3 text-center">Unidade</th>
                            <th className="border p-3 text-center">Peso/Embalagem</th>
                            <th className="border p-3 text-center">Custo Fixo</th>
                            <th className="border p-3 text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {produtosFiltrados.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="border p-4 text-center text-gray-500">
                                    Nenhum produto encontrado
                                </td>
                            </tr>
                        ) : (
                            produtosFiltrados.map(produto => (
                                <tr key={produto.id} className="hover:bg-gray-50">
                                    <td className="border p-3">{produto.nome}</td>
                                    <td className="border p-3 text-center">
                                        <span className="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm">
                                            {produto.unidade_peso}
                                        </span>
                                    </td>
                                    <td className="border p-3 text-center">
                                        {formatarPeso(produto.peso_embalagem, produto.unidade_peso)}
                                    </td>
                                    <td className="border p-3 text-center">
                                        {produto.custo_fixo 
                                            ? `R$ ${parseFloat(produto.custo_fixo).toFixed(2)}` 
                                            : '-'
                                        }
                                    </td>
                                    <td className="border p-3">
                                        <div className="flex justify-center gap-2">
                                            <button
                                                onClick={() => {
                                                    setProdutoEditado(produto);
                                                    setMostrarModal(true);
                                                }}
                                                className="bg-yellow-500 text-white p-2 rounded hover:bg-yellow-600"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button
                                                onClick={() => handleExcluir(produto.id)}
                                                className="bg-red-500 text-white p-2 rounded hover:bg-red-600"
                                            >
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Cards Mobile */}
            <div className="md:hidden space-y-4">
                {produtosFiltrados.length === 0 ? (
                    <div className="text-center text-gray-500 py-8">
                        Nenhum produto encontrado
                    </div>
                ) : (
                    produtosFiltrados.map(produto => (
                        <div key={produto.id} className="border rounded-lg p-4 bg-white shadow">
                            <div className="flex justify-between items-start mb-2">
                                <h3 className="font-semibold text-gray-800">{produto.nome}</h3>
                                <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                    {produto.unidade_peso}
                                </span>
                            </div>
                            <div className="space-y-1 text-sm text-gray-600 mb-3">
                                <p>
                                    <span className="font-medium">Peso/Embalagem:</span>{' '}
                                    {formatarPeso(produto.peso_embalagem, produto.unidade_peso)}
                                </p>
                                <p>
                                    <span className="font-medium">Custo:</span>{' '}
                                    {produto.custo_fixo 
                                        ? `R$ ${parseFloat(produto.custo_fixo).toFixed(2)}` 
                                        : '-'
                                    }
                                </p>
                            </div>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => {
                                        setProdutoEditado(produto);
                                        setMostrarModal(true);
                                    }}
                                    className="flex-1 bg-yellow-500 text-white px-3 py-2 rounded hover:bg-yellow-600"
                                >
                                    <FaEdit className="inline mr-1" /> Editar
                                </button>
                                <button
                                    onClick={() => handleExcluir(produto.id)}
                                    className="flex-1 bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
                                >
                                    <FaTrash className="inline mr-1" /> Excluir
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Modais */}
            {mostrarModal && (
                <ProdutoSemControleForm
                    produto={produtoEditado}
                    fecharModal={() => {
                        setMostrarModal(false);
                        setProdutoEditado(null);
                    }}
                    recarregar={carregarProdutos}
                />
            )}

            {mostrarImport && (
                <ProdutosSemControleImport
                    fecharModal={() => setMostrarImport(false)}
                    recarregar={carregarProdutos}
                />
            )}
        </div>
    );
};

export default ProdutosSemControleList;